import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { careCalendarCardBlockName } from '@gik/create/components';
import PageFeatureCard, { IPageFeatureCardProps } from '@gik/create/components/PageFeatureCard/PageFeatureCard';
import i18n from '@gik/i18n';
import { translationKeys } from '@gik/create/i18n/en';
import { PropsWithClassName } from '@gik/core/utils/ReactUtils';
import noop from '@gik/core/utils/noop';

export interface ICareCalendarCardProps extends Pick<IPageFeatureCardProps, 'inputName'> {
  onChange?: (values: boolean) => void;
  value: boolean;
  disabled?: boolean;
}

export default function CareCalendarCard({
  onChange = noop,
  value,
  inputName,
  className,
  disabled = false,
}: PropsWithClassName<ICareCalendarCardProps>) {
  const bem = bemBlock(careCalendarCardBlockName);
  return (
    <PageFeatureCard
      className={bem(null, null, className)}
      icon="Calendar"
      title={i18n.t(translationKeys.careCalendarTitle)}
      description={i18n.t(translationKeys.careCalendarDescription)}
      onChange={onChange}
      value={value}
      inputName={inputName}
      disabled={disabled}
    />
  );
}
